// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/users/subscription_groups_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupsData } from "./constants";
import type { SubscriptionGroupsDataParams, SubscriptionGroupsResult } from "./types";
import { isSubscriptionGroupsResult } from "./validators";

export const getSubscriptionGroupsData = reactQueryTableFetcherAdapter(
  usersSubscriptionGroupsData,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: SubscriptionGroupsDataParams
  ): Promise<SubscriptionGroupsResult> => {
    return fetch(
      "/users/subscription_groups_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isSubscriptionGroupsResult
);
